import React from 'react';

/**
 * BoldMatchingText Component
 * Makes matching text bold for search results
 * 
 * Props:
 * - text: string - The text to display
 * - query: string - The search query to bold
 */
const BoldMatchingText = ({ text, query }) => {
    if (!query || !query.trim()) return <span>{text}</span>;

    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);

    return (
        <span>
            {parts.map((part, index) =>
                regex.test(part) ? (
                    <strong key={index}>{part}</strong>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </span>
    );
};

export default BoldMatchingText;

